import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { Router, RouterEvent } from "@angular/router";
import {
    CclNavbarSecondaryService,
    CclSideNavItem,
    CclMessageService,
    CclNavbarFooterService
} from "certain-common-library";
import { SharedService } from "../../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
    selector: "app-item-context",
    templateUrl: "./catalog-context.view.html",
    styleUrls: []
})
export class CatalogContextView implements OnInit, AfterViewInit, OnDestroy {
    navLinks: CclSideNavItem[];
    private subscription: Subscription;

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private router: Router,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService
    ) {
        this.navSecondaryService.includeSave = false;
        this.navLinks = [
            {
                label: "Define Layout",
                icon: "fa-sliders",
                route: "setting"
            },
            {
                label: "Design Elements",
                icon: "fa-list-alt",
                route: "layout"
            },
            {
                label: "Data",
                icon: "fa-database",
                route: "data"
            },
            {
                label: "Additional Settings",
                icon: "fa-briefcase",
                route: "add-setting"
            }
        ];
        this.subscription = this.messageService.getMessage().subscribe((message) => this.changeContext(message));
        this.router.events.pipe(filter((e) => e instanceof RouterEvent)).subscribe((e) => {
            if (e["urlAfterRedirects"] == "/admin/" + this.sharedService.catalogUUID + "/catalog/data/highlighted") {
                if (
                    this.sharedService.catalogLayoutConfig.vipUnit != "card" &&
                    this.sharedService.catalogLayoutConfig.vipUnit != "list"
                ) {
                    this.sharedService.catalogNavigateHelper("admin", "catalog/data/general");
                }
            }

            if (this.navbarFooterService.navbar != null) {
                if (e["url"] == "/admin/" + this.sharedService.catalogUUID + "/catalog/add-setting/additional-setting") {
                    this.navbarFooterService.navbar.rightNavbarItems[2].label = "SAVE & PREVIEW";
                } else {
                    this.navbarFooterService.navbar.rightNavbarItems[2].label = "SAVE & NEXT";
                }
            }
        });
    }

    ngOnInit() {}

    ngAfterViewInit(): void {
        this.navSecondaryService.contextLabel =
            this.sharedService.account.name +
            " - " +
            this.sharedService.event.name +
            " - " +
            this.sharedService.setup.catalogName;
        document.title = "Speaker Catalog Admin - " + this.sharedService.setup.catalogName;
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    changeContext(message) {
        if (message.text == "update-context") {
            this.navSecondaryService.contextLabel =
                message.data.account.name + " - " + message.data.event.name + " - " + message.data.catalog.catalogName;
        } else if (message.text == "use-default") {
            this.openPopup(message.data.popupName);
        }
    }

    openPopup(item) {
        this.sharedService.currentPopup = {
            title: null,
            navLinks: null,
            saveMessage: null,
            showFooter: false
        };
        let url = "popup/default-setup";
        this.sharedService.navigateToOutlet("popup", url);
    }
}
